import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { CustomerService } from 'src/app/services/customer/customer.service';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { RedirctUrlService } from 'src/app/shared/services/redirct-url.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { DeleteUserComponent } from '../../users/delete-user/delete-user.component';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { SupplierReleaseRequirementsModalComponent } from 'src/app/components/customers/customer/supplier-release-requirements-modal/supplier-release-requirements-modal.component';
import { HeaderService } from 'src/app/shared/services/header/header.service'
import { AppNotificationService } from 'src/app/shared/services/app-notification.service'
@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss']
})
export class CustomerComponent implements OnInit {
  private sub:any;
  public params:any;
  public customer:any;
  public customerUsers: any[] =[];
  public customerLoadCounts:{};
  public filteredCustomerUsers: any[] =[];
  public filteredHeader: string;
  public promptDeleteUser: boolean = false;
  public userToDelete: any;
  public loading: boolean= false;
  public openSupplierReleaseRequirements: boolean = false;
  public urlPath: any;
  public subuserTitle: string;
  public filterSearch: string;
  public currentUser: string;
  public p: any;
  public notifications: any[] = [];
  public readOnly: boolean = true;

  constructor(
    private customerService:CustomerService,
    private location:Location,
    private _redirectUrl: RedirctUrlService,
    private route:ActivatedRoute,
    public currentUserService: CurrentUserService,
    private modal: ModalService,
    private flashMessageService: FlashMessageService,
    public _header: HeaderService,
    public appNotificationsService: AppNotificationService
  ) { }

  async ngOnInit() {
    this.loading = true;
    this.getUsers();
    this.urlPath = this.route.snapshot;
    this.currentUserService.getUser().then(user => {
      this.currentUser = this.currentUserService.user.firstname;
      if (this.currentUserService.user.userEntitlements.find(entitlement => entitlement.code === 'HC_INTERNAL_UPDATE_CUSTOMER')) {
        this.readOnly = false;
      } else {
        this.readOnly = true;
      }
    });

    if (await this.appNotificationsService.getNotificationEnabledStatus()) this.appNotificationsService.loadNotifications('general', 0);
  }

  ngOnDestroy() {

  }

  public getUsers(){
    this.route.params.subscribe(params => {
      this.customerService.getCustomerUsersAndCounts(params['id']).then((resp) => {
        this.customerUsers = resp['customerUsers'];
        this.filteredCustomerUsers = resp['customerUsers'];
        this.customerLoadCounts = resp['orderStatusCounts'];
        this.loading = false;
      }).catch(e => this.loading = false);
      if( this.customerService.all.length ) {
        this.customer = this.customerService.getCustomer(params['id']);
      } else {
        this.customerService.getCustomers().then(() => {
          this.customer = this.customerService.getCustomer(params['id']);
        });
      }
    });
  }

  public userRole(user) {
    switch (user['applications'][0]['roleCode']) {
      case 'HC_CUSTOMER_ADMIN':
        return 'Admin';
      case 'HC_CUSTOMER_USER':
        return 'User';
      case 'HC_CUSTOMER_CLAIMS_USER':
        return 'Claims User';
      case 'HC_CUSTOMER_ADHOC':
        return 'Custom User';
      case 'HC_INTERNAL_ADMIN':
        return 'Hub Admin';
      case 'HC_CUSTOMER_LOGISTICS_ADMIN':
        return 'Logistics Admin';
      case 'HC_CUSTOMER_LOGISTICS_USER':
        return 'Logistics User';
    }
  }

  public filterCustomerUsers(filterOption){
    if (filterOption === 'all'){
      this.filteredCustomerUsers = this.customerUsers;
    } else {
      this.filteredCustomerUsers = this.customerUsers.filter(customer => customer['applications'][0]['roleCode'] === filterOption);
    }

    switch(filterOption) {
      case 'all':
        this.filteredHeader = "";
        break;
      case 'HC_CUSTOMER_ADMIN':
        this.filteredHeader = "Admin ";
        break;
      case 'HC_CUSTOMER_USER':
        this.filteredHeader = "Customer ";
        break;
      case 'HC_CUSTOMER_ADHOC':
        this.filteredHeader = "Custom ";
        break;
      case 'HC_CUSTOMER_CLAIMS_USER':
        this.filteredHeader = "Claims ";
        break;
      case 'HC_CUSTOMER_LOGISTICS_ADMIN':
        this.filteredHeader = "Logistics Admin ";
        break;
      case 'HC_CUSTOMER_LOGISTICS_USER':
        this.filteredHeader = "Logistics Customer ";
        break;
    }
  }

  public closeModal() {
    this.promptDeleteUser = false;
    this.userToDelete = null;
    this.getUsers();
  }

  public back() {
    this.location.back();
  }

  onRedirectHandler($event) {
    this._redirectUrl.onLogoutHandler($event);
  }
  onBackEventHandler(){
    this.location.back();
  }

  openModal(type: string, data = null) {
    if (type === 'customerOnboarding') {
      this.modal.open(SupplierReleaseRequirementsModalComponent, { customerId: this.customer.id, readOnly: this.readOnly })
    } else if (type === 'deleteUser') {
      if (data) {
        this.userToDelete = data;
      } else {
        this.flashMessageService.updateMessage("User data to delete was not found", 3000, "danger")
        return;
      }
      let subscription = this.modal.closeEvent.subscribe(() => {
        this.closeModal();
        subscription.unsubscribe();
      })
      this.modal.open(DeleteUserComponent, this.userToDelete);
    } else {}
  }

}
